export default __webpack_public_path__ + "static/media/weightlossregime_3@2x.c5b861b6.jpg";